



































































import Vue from 'vue';
import * as icons from '@/icons';
import { searchIcons, shelfCounts } from '@/icons/search';

import Icon from '@/components/Icon.vue';

// The item groups treat an empty value as "use the index", so All gets a name.
const ALL_ICONS = 'ALL';

interface ShelfOption {
  value: string;
  name: string;
  count: number;
}

export default Vue.extend({
  components: {
    Icon
  },

  data() {
    return {
      query: '' as string | null,
      shelf: ALL_ICONS
    };
  },

  computed: {
    // Categories in a left panel on wide screens, a dropdown on narrow ones.
    wide(): boolean {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    shelfName(): string | null {
      return this.shelf === ALL_ICONS ? null : this.shelf;
    },

    icons(): icons.IconData[] {
      return searchIcons(this.query || '', this.shelfName);
    },

    // All, then the shelves; with a query, only the shelves holding a match,
    // the most matches first.
    shelfOptions(): ShelfOption[] {
      const query = this.query || '';
      const all = {
        value: ALL_ICONS,
        name: 'All icons',
        count: this.shelfName ? searchIcons(query).length : this.icons.length
      };

      return [
        all,
        ...shelfCounts(query, this.shelfName).map(({ name, count }) => ({
          value: name,
          name,
          count
        }))
      ];
    }
  },

  watch: {
    // A new list starts at its top, not wherever the last one was scrolled to.
    query() {
      this.scrollToTop();
    },

    shelf() {
      this.scrollToTop();
    }
  },

  methods: {
    scrollToTop() {
      const grid = this.$refs.grid as HTMLElement | undefined;

      if (grid) {
        grid.scrollTop = 0;
      }
    },

    selectIcon(iconData: icons.IconData) {
      this.$emit('icon-selected', iconData);
    }
  }
});
